import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";

import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Table from "react-bootstrap/Table";
import Col from "react-bootstrap/esm/Col";

import Accordion from 'react-bootstrap/Accordion';
import Modal from 'react-bootstrap/Modal';
import Collapse from 'react-bootstrap/Collapse';


import ButtonGroup from 'react-bootstrap/ButtonGroup';

import { permite_acesso, total_monitora } from "../../services/api";
// nada não

const Totalizacao_unidade = (props) => {

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    let tipochart = "";

    const [data2, setData2] = useState([]);
    const [chartData2, setCharData2] = useState([]);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showText, setShowText] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);


    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    const fetchData = async () => {
        try {
            const response = await total_monitora(data_inicio, data_fim);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    const transpose = (matrix) => {
        return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
    };
    useEffect(() => {
        function handleWindowResize() {
            setWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    useEffect(() => {
        // Se a largura da tela for maior que 600px, exibe o texto por padrão
        if (width > 600) {
            setShowText(true);
        } else {
            setShowText(false);
        }
    }, [width]);
    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    const toggleText = () => {
        setShowText(!showText);
    };
    let t2027 = 0;
    let t2026 = 0;
    let t2025 = 0;
    let t2024 = 0;

    let chartDataTotal = [];

    if (typeof data2 !== 'undefined') {
        chartDataTotal = data2.map((item, index) => {
            if (item.unidade === cod_unidade) {
                console.log("entrei")
                const row = [unidades[parseInt(item.unidade)]];
                row.push(item.t2027 || 0);
                row.push(item.t2026 || 0);
                row.push(item.t2025 || 0);
                t2027 += parseInt(item.t2027);
                t2026 += parseInt(item.t2026);
                t2025 += parseInt(item.t2025);

                return row;
            }
        });
    };

    chartDataTotal.unshift(['Unidade', '2027', '2026', '2025']);

    let mh2027 = 0;
    let mh2026 = 0;
    let mh2025 = 0;
    let mh2024 = 0;

    let chartDataMatriculaHoje = [];

    if (typeof data2 !== 'undefined') {
        chartDataMatriculaHoje = data2.map((item, index) => {
            if (item.unidade === cod_unidade) {
                const row = [unidades[parseInt(item.unidade)]];
                row.push(item.mh2027 || 0);
                row.push(item.mh2026 || 0);
                row.push(item.mh2025 || 0);
                mh2027 += parseInt(item.mh2027);
                mh2026 += parseInt(item.mh2026);
                mh2025 += parseInt(item.mh2025);
                return row;
            }
        });
        chartDataMatriculaHoje.unshift(['Unidade', '2027', '2026', '2025']);
    };


    let ch2027 = 0;
    let ch2026 = 0;
    let ch2025 = 0;
    let ch2024 = 0;

    let chartDataCH = [];
    if (typeof data2 !== 'undefined') {
        chartDataCH = data2.map((item, index) => {
            if (item.unidade === cod_unidade) {
                const row = [unidades[parseInt(item.unidade)]];
                row.push(item.ch2027 || 0);
                row.push(item.ch2026 || 0);
                row.push(item.ch2025 || 0);

                ch2027 += parseInt(item.ch2027);
                ch2026 += parseInt(item.ch2026);
                ch2025 += parseInt(item.ch2025);

                return row;
            }
        });
        chartDataCH.unshift(['Unidade', '2027', '2026', '2025']);
    };

    let a2027 = 0;
    let a2026 = 0;
    let a2025 = 0;


    let chartDataAtivos = [];
    if (typeof data2 !== 'undefined') {
        chartDataAtivos = data2.map((item, index) => {
            if (item.unidade === cod_unidade) {
                const row = [unidades[parseInt(item.unidade)]];
                row.push(item.a2027 || 0);
                row.push(item.a2026 || 0);
                row.push(item.a2025 || 0);

                a2027 += parseInt(item.a2027);
                a2026 += parseInt(item.a2026);
                a2025 += parseInt(item.a2025);

                return row;
            }
        });

        chartDataAtivos.unshift(['Unidade', '2027', '2026', '2025']);
    };

    let c2027 = 0;
    let c2026 = 0;
    let c2025 = 0;


    let chartDataCancelados = [];

    if (typeof data2 !== 'undefined') {
        chartDataCancelados = data2.map((item, index) => {
            if (item.unidade === cod_unidade) {
                const row = [unidades[parseInt(item.unidade)]];
                row.push(item.c2027 || 0);
                row.push(item.c2026 || 0);
                row.push(item.c2025 || 0);

                c2027 += parseInt(item.c2027);
                c2026 += parseInt(item.c2026);
                c2025 += parseInt(item.c2025);
                return row;
            };
        });
        chartDataCancelados.unshift(['Unidade', '2027', '2026', '2025']);

    };

    let x2027 = 0;
    let x2026 = 0;
    let x2025 = 0;

    let chartDataX = [];
    if (typeof data2 !== 'undefined') {
        chartDataX = data2.map((item, index) => {
            if (item.unidade === cod_unidade) {
                const row = [unidades[parseInt(item.unidade)]];
                row.push(item.x2027 || 0);
                row.push(item.x2026 || 0);
                row.push(item.x2025 || 0);
                x2027 += parseInt(item.x2027);
                x2026 += parseInt(item.x2026);
                x2025 += parseInt(item.x2025);

                return row;
            };
        });

        chartDataX.unshift(['Unidade', '2027', '2026', '2025']);
    };


    const handleShowCanc = () => {
        setCharData2(chartDataCancelados);
        setShow(true);
    }
    const handleShowTotal = () => {
        setCharData2(chartDataTotal);
        setShow(true);
    }
    const handleShowAtivos = () => {
        setCharData2(chartDataAtivos);
        setShow(true);
    }
    const handleShowMH = () => {
        setCharData2(chartDataMatriculaHoje);
        setShow(true);
    }
    const handleShowCH = () => {
        setCharData2(chartDataCH);
        setShow(true);
    }


    return (
        <div className="totais">
            <Row>
                {width <= 600 ? (
                    <Button
                        onClick={toggleText}
                        aria-controls="example-collapse-text"
                        aria-expanded={showText}
                    >

                        <Col sm={4} lg={4} >

                            <b> Total: </b> {t2027 - c2027} <b> Hoje: </b> {mh2027}  <b>  Ativos: </b>  {a2027}

                        </Col>

                    </Button>
                ) : null}

            </Row>
            <Collapse in={showText}>
                <ButtonGroup className="mb-2">
                    <Button variant="primary" >
                        <Row>
                            <h5>Total de Alunos:</h5>
                            <Col sm={4} lg={4}> <b> 2027: </b> <h6> {t2027 - c2027} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2026: </b> <h6> {t2026 - c2026} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2025: </b> <h6> {t2025 - c2025} </h6> </Col>

                        </Row>
                    </Button>
                    <Button variant="info" >
                        <Row>
                            <h5>Matriculas Hoje:</h5>
                            <Col sm={4} lg={4}> <b> 2027: </b> <h6> {mh2027} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2026: </b> <h6> {mh2026} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2025: </b> <h6> {mh2025} </h6> </Col>
                        </Row>
                    </Button>
                    <Button variant="secondary">
                        <Row>
                            <h5>Em andamento:</h5>
                            <Col sm={4} lg={4}> <b> 2027: </b> <h6> {x2027} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2026: </b> <h6> {x2026} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2025: </b> <h6> {x2025} </h6> </Col>
                        </Row>
                    </Button>
                    <Button variant="success" >
                        <Row>
                            <h5>Alunos Ativos:</h5>
                            <Col sm={4} lg={4}> <b> 2027: </b> <h6> {a2027} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2026: </b> <h6> {a2026} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2025: </b> <h6> {a2025} </h6> </Col>

                        </Row>
                    </Button>
                    <Button variant="danger" >
                        <Row>
                            <h5>Alunos Cancelados:</h5>
                            <Col sm={4} lg={4}> <b> 2027: </b> <h6> {c2027} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2026: </b> <h6> {c2026} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2025: </b> <h6> {c2025} </h6> </Col>

                        </Row>
                    </Button>
                    <Button variant="warning" >
                        <Row>
                            <h5>Cancelados Hoje:</h5>
                            <Col sm={4} lg={4}> <b> 2027: </b> <h6> {ch2027} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2026: </b> <h6> {ch2026} </h6> </Col>
                            <Col sm={4} lg={4}> <b> 2025: </b> <h6> {ch2025} </h6> </Col>

                        </Row>
                    </Button>

                </ButtonGroup>
            </Collapse>
            <Modal show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Total de Alunos:</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Chart
                        chartType="Table"
                        version="current"
                        width="350px"
                        data={chartData2}
                    />
                </Modal.Body>
            </Modal>


        </div>

    );
};


export default Totalizacao_unidade;